<template>
  <q-page class="product-page q-mt-md">
    <div class="">
      <template v-if="product">
        <!-- Хлебные крошки -->
        <div class="c-breadcrumbs q-mb-md q-px-md q-px-md-none">
          <q-breadcrumbs>
            <q-breadcrumbs-el
                to="/"
                :icon="ICONS.homeOutline"
            >
              <span class="gt-md q-ml-sm">Главная</span>
            </q-breadcrumbs-el>
            <q-breadcrumbs-el
                v-if="section"
                :label="section.NAME || ''"
                :to="'/#' + section.CODE"
            />
            <q-breadcrumbs-el :label="product.NAME"/>
          </q-breadcrumbs>
        </div>

        <!-- Контент товара в карточке -->
        <div class="c-product-card">
          <ProductModal
              :product="product"
              mode="dialog"
              :basket-item-uuid="basketItemUuid"
          >
            <template #title>
              <h1 class="i-title s-font-sm-2xl s-font-md-3xl s-font-lg-4xl s-font-xl-4xl text-weight-bolder leading-e4 q-ma-none q-m">
                {{ product.NAME }}
              </h1>
            </template>
          </ProductModal>
        </div>
      </template>
      <template v-else-if="!isLoading">
        <div class="c-not-found text-center q-pa-xl">
          <div class="text-h6 text-grey-7">Товар не найден</div>
          <q-btn
              flat
              color="primary"
              label="На главную"
              to="/"
              class="q-mt-md"
          />
        </div>
      </template>
    </div>
  </q-page>
</template>

<script setup lang="ts">
import {computed, watch} from "vue";
import {useCatalogStore} from "@/modules/shop/store/catalog";
import {usePageFrontStore} from "@/stores/page-front";
import {storeToRefs} from "pinia";
import ProductModal from "@/components/Shop/ProductCard/ProductModal.vue";
import {StackComponentProps} from "@/packages/stack-router/hooks/useStackComponent";
import {ICONS} from "@/assets/icons";
import {usePageMeta} from "@/core/store/page-meta";
import {useMeta} from "quasar";

const props = withDefaults(defineProps<StackComponentProps & {
  id: string,
  baskethash?: string | string[] | null,
}>(), {})

const basketItemUuid = computed(() => {
  const value = Array.isArray(props.baskethash) ? props.baskethash[0] : props.baskethash
  return value || undefined
})

const catalogStore = useCatalogStore();
const pageFrontStore = usePageFrontStore();

const {productsModelsById, sectionsById, sections} = storeToRefs(catalogStore);
const {activeSection} = storeToRefs(pageFrontStore);

const product = computed(() => productsModelsById.value[props.id]);

const section = computed(() => {
  if (!product.value) return null;
  const sectionId = product.value.IBLOCK_SECTION_ID;
  return sectionId ? sectionsById.value[sectionId] : null;
});

const isLoading = computed(() => sections.value.length === 0);

// Синхронизация активной секции в меню
watch(section, (sec) => {
  if (sec?.CODE) {
    activeSection.value = sec.CODE;
  }
}, {immediate: true});

const {fillMeta} = usePageMeta()

useMeta(() => {
  return fillMeta({
    title: product.value?.NAME || 'Товар'
  })
})

</script>

<style lang="scss" scoped>
.product-page {
  padding-bottom: 32px;
}

.c-product-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px -4px rgba(34, 60, 80, 0.15);
  padding: 24px;

  @media (max-width: $breakpoint-sm-max) {
    border-radius: 12px;
    padding: 16px;
  }
}

.c-not-found {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px -4px rgba(34, 60, 80, 0.15);
}
</style>
